import MlmJob from '~/tenants/mlm/model/MlmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import MlmWalkthroughConfig from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughConfig';
import { TenantJobLine } from '~/lib/model';
import Big from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export const MLM_WALKTHROUGH_AGENT = 200;

export default class MlmWalkthroughJob extends MlmJob<typeof MlmWalkthroughConfig> {
  get performable() {
    return MlmWalkthroughConfig;
  }

  get configurable() {
    return true;
  }

  get deliverable() {
    return DeliverableType.VIDEO;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  onsite() {
    let onsite = 60;

    if (this.metadata.agent) {
      onsite += 60;
    }

    return onsite;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MlmWalkthroughConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines = super.revenueLines();

    lines.push({
      id: 'walkthrough',
      discountable: true,
      description: 'Walkthrough Video',
      amount: new Big(300),
    });

    if (this.metadata.agent) {
      lines.push({
        id: 'agent',
        discountable: true,
        description: 'Agent on Camera',
        amount: new Big(MLM_WALKTHROUGH_AGENT),
      });
    }

    return lines;
  }
}
